// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2IvZU","productName":"Table_productName__3PJBs"};